import type { CommendaOSFilter } from '@commenda/types';

export interface DocumentEffectivePeriod {
  effectiveStartDate?: string | null;
  effectiveEndDate?: string | null;
}

export class DocumentEffectivePeriodHelper {
  /** Dates are `YYYY-MM-DD`, so lexical order is calendar order. */
  static isValid({
    effectiveStartDate,
    effectiveEndDate,
  }: Readonly<DocumentEffectivePeriod>): boolean {
    return (
      !effectiveStartDate ||
      !effectiveEndDate ||
      effectiveStartDate <= effectiveEndDate
    );
  }

  /** The configured period with empty dates removed. */
  static getConfiguredPeriod({
    effectiveStartDate,
    effectiveEndDate,
  }: Readonly<DocumentEffectivePeriod>): DocumentEffectivePeriod {
    return {
      ...(effectiveStartDate ? { effectiveStartDate } : {}),
      ...(effectiveEndDate ? { effectiveEndDate } : {}),
    };
  }

  /**
   * Filters identifying a corporation document: its sub-type plus, when the
   * template configures one, its effective period.
   */
  static getDocumentFilters(
    documentSubType: string,
    period: Readonly<DocumentEffectivePeriod>
  ): CommendaOSFilter[] {
    const { effectiveStartDate, effectiveEndDate } =
      DocumentEffectivePeriodHelper.getConfiguredPeriod(period);
    return [
      { key: 'documentSubType', value: documentSubType },
      ...(effectiveStartDate
        ? [{ key: 'effectiveStartDate', value: effectiveStartDate }]
        : []),
      ...(effectiveEndDate
        ? [{ key: 'effectiveEndDate', value: effectiveEndDate }]
        : []),
    ];
  }

  static buildDocumentsReadPath(filters: readonly CommendaOSFilter[]): string {
    const filterStr = filters.map((f) => `${f.key}=${f.value}`).join(',');
    return `documents[${filterStr}]`;
  }
}
